// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map {
  margin-right: 10px;
}

.map-row {
  min-height: 40vh;
}

.row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.properties-table {
  height: 92.5vh;
}

/* .filterInput{
  width:90% !important;
  display: inline-flex !important;
  margin-left: 8px;
  margin-bottom: 8px;
} */
/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version. */
.mat-select-disabled,
.mat-select-value {
  background-color: lightgray;
}

.mat-mdc-select-panel {
  font-size: 12px;
}

/* Temporary Workaround:
 * changing the width of dropdown
 */
::ng-deep .mat-select-panel {
  margin-top: 27px;
  background: #fff;
  max-height: 300px;
  min-width: 100% !important;
}

::ng-deep div.mat-mdc-select-panel {
  width: 100%;
  max-height: 275px;
  outline: 0;
  overflow: auto;
  padding: 8px 0;
  border-radius: 4px;
  box-sizing: border-box;
  position: static;
  background-color: white;
}

::ng-deep .cdk-overlay-pane {
  position: absolute;
  pointer-events: auto;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  max-width: 100%;
  max-height: 100%;
  background-color: white;
}

/* .mat-mdc-select{display:inline-block;width:100%;outline:none;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;color:var(--mat-select-enabled-trigger-text-color);font-family:var(--mat-select-trigger-text-font);line-height:var(--mat-select-trigger-text-line-height);font-size:var(--mat-select-trigger-text-size);font-weight:var(--mat-select-trigger-text-weight);letter-spacing:var(--mat-select-trigger-text-tracking)}div.mat-mdc-select-panel{box-shadow:var(--mat-select-container-elevation-shadow)}.mat-mdc-select-disabled{color:var(--mat-select-disabled-trigger-text-color)}.mat-mdc-select-trigger{display:inline-flex;align-items:center;cursor:pointer;position:relative;box-sizing:border-box;width:100%}.mat-mdc-select-disabled .mat-mdc-select-trigger{-webkit-user-select:none;user-select:none;cursor:default}.mat-mdc-select-value{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-mdc-select-value-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.mat-mdc-select-arrow-wrapper{height:24px;flex-shrink:0;display:inline-flex;align-items:center}.mat-form-field-appearance-fill .mdc-text-field--no-label .mat-mdc-select-arrow-wrapper{transform:none}.mat-mdc-form-field .mat-mdc-select.mat-mdc-select-invalid .mat-mdc-select-arrow,.mat-form-field-invalid:not(.mat-form-field-disabled) .mat-mdc-form-field-infix::after{color:var(--mat-select-invalid-arrow-color)}.mat-mdc-select-arrow{width:10px;height:5px;position:relative;color:var(--mat-select-enabled-arrow-color)}.mat-mdc-form-field.mat-focused .mat-mdc-select-arrow{color:var(--mat-select-focused-arrow-color)}.mat-mdc-form-field .mat-mdc-select.mat-mdc-select-disabled .mat-mdc-select-arrow{color:var(--mat-select-disabled-arrow-color)}.mat-mdc-select-arrow svg{fill:currentColor;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}.cdk-high-contrast-active .mat-mdc-select-arrow svg{fill:CanvasText}.mat-mdc-select-disabled .cdk-high-contrast-active .mat-mdc-select-arrow svg{fill:GrayText}div.mat-mdc-select-panel{width:100%;max-height:275px;outline:0;overflow:auto;padding:8px 0;border-radius:4px;box-sizing:border-box;position:static;background-color:white}.cdk-high-contrast-active div.mat-mdc-select-panel{outline:solid 1px}.cdk-overlay-pane:not(.mat-mdc-select-panel-above) div.mat-mdc-select-panel{border-top-left-radius:0;border-top-right-radius:0;transform-origin:top center}.mat-mdc-select-panel-above div.mat-mdc-select-panel{border-bottom-left-radius:0;border-bottom-right-radius:0;transform-origin:bottom center}div.mat-mdc-select-panel .mat-mdc-option{--mdc-list-list-item-container-color: white}.mat-mdc-select-placeholder{transition:color 400ms 133.3333333333ms cubic-bezier(0.25, 0.8, 0.25, 1);color:var(--mat-select-placeholder-text-color)}._mat-animation-noopable .mat-mdc-select-placeholder{transition:none}.mat-form-field-hide-placeholder .mat-mdc-select-placeholder{color:rgba(0,0,0,0);-webkit-text-fill-color:rgba(0,0,0,0);transition:none;display:block}.mat-mdc-form-field-type-mat-select:not(.mat-form-field-disabled) .mat-mdc-text-field-wrapper{cursor:pointer}.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-fill .mat-mdc-floating-label{max-width:calc(100% - 18px)}.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-fill .mdc-floating-label--float-above{max-width:calc(100%/0.75 - 24px)}.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-outline .mdc-notched-outline__notch{max-width:calc(100% - 60px)}.mat-mdc-form-field-type-mat-select.mat-form-field-appearance-outline .mdc-text-field--label-floating .mdc-notched-outline__notch{max-width:calc(100% - 24px)}.mat-mdc-select-min-line:empty::before{content:" ";white-space:pre;width:1px;display:inline-block;visibility:hidden}.mat-form-field-appearance-fill .mat-mdc-select-arrow-wrapper{transform:var(--mat-select-arrow-transform)}
 */
/* TODO(mdc-migration): The following rule targets internal classes of option that may no longer apply for the MDC version. */
::ng-deep .mat-primary .mat-mdc-option.mat-selected:not(.mat-option-disabled) {
  color: unset;
}

::ng-deep .mat-mdc-option-pseudo-checkbox.mat-pseudo-checkbox-checked {
  background: var(--theme-primary-button-color, #055C8D);
}

.mat-mdc-select-panel .mat-mdc-optgroup-label,
.mat-select-panel .mat-mdc-option {
  font-size: inherit;
  line-height: 1.5;
  height: 2em;
}

.query-builder-container {
  max-height: 55vh;
  height: 55vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.result-grid-accordian-body {
  height: 79vh;
  overflow-y: scroll;
}

.search-applications-table {
  height: 90%;
}

.filter-row {
  border: 1px solid #EAEAEA;
  border-radius: 0.25rem;
  background-color: #F8F8F8;
  margin: 0 0 8px 0;
  padding-top: 8px;
  padding-bottom: 8px;
}

.summary {
  border-top: 1px solid rgba(151, 151, 151, 0.2588235294) !important;
  padding-bottom: 10%;
  width: 400px;
}

.new-application-link {
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.254903px;
  cursor: pointer;
  color: #FFFFFF;
}

.form-margin-bottom {
  margin-bottom: 15px;
}

.applications-table {
  height: 90%;
}

.new-application-button .secondary {
  padding-left: 10px;
  padding-right: 10px;
}

.map {
  margin-right: 10px;
}

.map-row {
  min-height: 37vh;
}

.row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.summary-expand-button {
  position: absolute;
  right: -59px;
  top: 50%;
  height: 32px;
  width: 150px;
  transform: rotate(270deg);
  background-color: var(--theme-primary-button-color, #055C8D);
  border-top: 1px solid rgba(151, 151, 151, 0.2588235294) !important;
  border-radius: 80px 80px 0px 0px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 10px;
  overflow: hidden;
  text-align: center;
  opacity: 0.6;
}

.summary-expand-button:hover {
  background-color: var(--theme-main-darker-color, #053551);
  opacity: 1;
}

.summary-expand-button:hover ::ng-deep app-primary-button button {
  background-color: transparent !important;
}

.vertical-button {
  margin-top: 10px;
}

.accordion-heading {
  border: 1px solid #EAEAEA;
  border-radius: 0.25rem;
  background-color: #F8F8F8;
  padding-left: 8px !important;
}

.description-label {
  padding-top: 16px;
  padding-bottom: 16px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
